













import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  name = process.env.VUE_APP_NAME;
  version = process.env.VERSION;
}
